import { render, staticRenderFns } from "./LeadScore.vue?vue&type=template&id=6f40ae67&scoped=true"
import script from "./LeadScore.vue?vue&type=script&lang=js"
export * from "./LeadScore.vue?vue&type=script&lang=js"
import style0 from "./LeadScore.vue?vue&type=style&index=0&id=6f40ae67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40ae67",
  null
  
)

export default component.exports